/* ============================================================================
   cro-fixes.js — Quirky Moose
   Oprettet 2026-08-11 på baggrund af CRO-Mobil-Audit-2026-08-10.
   Indlæses fra snippets/product-variant-picker.liquid.
   ROLLBACK: slet <script>-linjen i det snippet — så er alt som før.
   ========================================================================= */

/* ── Fix 4: stop URL-opdatering ved variantskift ────────────────────────────

   Ved hvert farveklik kalder assets/product-info.js updateURL(), som kører
   history.replaceState og skriver ?variant=<id> i adresselinjen.

   Det er IKKE en sidegenindlæsning — det blev efterprøvet 2026-08-11:
   navigation-entries forbliver 1, og window-objektet overlever. Rapportens
   oprindelige formulering om "fuld sidenavigation" var forkert.

   Problemet er måling: både Clarity og Shopify tæller hver replaceState som
   en ny sidevisning. Én målt mobilsession havde 33 sidevisninger fordelt på
   6 unikke URL'er. Det oppuster sidevisningstal, sænker den rapporterede
   tid-per-side og skjuler den reelle adfærd i alle fremtidige audits.

   Gaten ligger på <product-info data-update-url>, IKKE på <variant-selects>.
   Attributten sættes til "true" i sections/main-product.liquid (101 KB), så
   den slås fra her i stedet for at redigere den fil.

   BIVIRKNING: deler en kunde et link efter at have valgt en farve, peger
   linket på produktets standardfarve. Indgående ?variant=-links fra annoncer,
   mails og Pinterest virker uændret — det er kun opdateringen undervejs.
   ------------------------------------------------------------------------- */
(() => {
  const disableVariantUrlUpdates = () => {
    document.querySelectorAll('product-info[data-update-url="true"]').forEach((el) => {
      el.dataset.updateUrl = 'false';
    });
  };

  disableVariantUrlUpdates();
  document.addEventListener('DOMContentLoaded', disableVariantUrlUpdates);
  // Sektioner kan gen-renderes af theme editor og af Shopify-apps
  document.addEventListener('shopify:section:load', disableVariantUrlUpdates);
})();
